import { ReactElement } from 'react'
import IconButton from '@mui/material/IconButton'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { useAppDispatch } from 'src/store/hooks'
import {
  errorMessageChanged,
  successMessageChanged,
} from '../admin/admin.slice'

interface CopyToClipboardProps {
  textToCopy: string
  messageLabel: string
  color?:
    | 'inherit'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning'
}

export let CopyToClipboard = ({
  textToCopy,
  messageLabel,
  color = 'primary',
}: CopyToClipboardProps): ReactElement => {
  let dispatch = useAppDispatch()

  let copyToClipboard = (text: string, label: string) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        dispatch(successMessageChanged(`${label} copied to clipboard!`))
      })
      .catch(() => {
        dispatch(errorMessageChanged('Failed to copy to clipboard'))
      })
  }
  return (
    <IconButton
      size="small"
      color={color}
      onClick={() => copyToClipboard(textToCopy || '', messageLabel)}
    >
      <ContentCopyIcon fontSize="small" />
    </IconButton>
  )
}
